/** "Continue as Guest": creates a throwaway-named account on the server and signs straight in. */
import { useState } from 'react';
import type { AuthResponse } from '@cardhub/protocol';
import { api } from '../api/client';
import { useT } from '../i18n';
import { deviceId } from '../lib/device';
import { errorMessage } from '../lib/hooks';
import { useSettings } from '../store/settings';
import { toast } from '../store/ui';

export function GuestButton({ onSignedIn }: { onSignedIn: (res: AuthResponse) => void }) {
  const t = useT();
  const lang = useSettings((s) => s.settings.language);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      onSignedIn(await api.post<AuthResponse>('/api/v1/auth/guest', { deviceId: deviceId(), language: lang }));
    } catch (e) {
      toast(errorMessage(e), 'error');
      setBusy(false);
    }
  };
  return (
    <button type="button" className="btn ghost block" disabled={busy} onClick={() => void go()}>
      {t('auth.guest')}
    </button>
  );
}
